import { render, staticRenderFns } from "./CreateCampaigns.vue?vue&type=template&id=7d118466&scoped=true"
import script from "./CreateCampaigns.vue?vue&type=script&lang=js"
export * from "./CreateCampaigns.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaigns.vue?vue&type=style&index=0&id=7d118466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d118466",
  null
  
)

export default component.exports